const DATA_BOOTSTRAP_URL = 'https://storage.googleapis.com/storage/v1/b/app-cc-data/o/mgocjn6ess%2Finstallations-2021-02-21.proto?alt=media';
import { InstallationsStore } from '../schemas/installations_pb.js';
async function getInstallations() {
    const response = await fetch(DATA_BOOTSTRAP_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'text/plain',
        },
    });
    const data = await response.arrayBuffer();
    installations = InstallationsStore.deserializeBinary(data).toObject().installationsList;
    return installations;
}
export let installations = getInstallations();
